import React from 'react';
import {Row,Col} from 'react-bootstrap'
import Header from '../../Components/Modules/Includes/Header'
import MdEmail from 'react-icons/lib/md/email'
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';

import { connect } from 'react-redux';
import * as actions from '../../Actions/profile';
import env from '../../config/env.js'
const apiUrl=env.apiUrl;
class ChangePassword extends React.Component{
	constructor(props){
		super(props);
		this.state={
			oldpass: '',
			newpass: '',
			verifypass: '',
			passMisMatchText: '',
			newPassReq: '',
			oldPassReq: '',
			passMatchReq: '' ,
			wrongPassMsg: ''
		};
		this.setPassword=this.setPassword.bind(this);
		this.chnagePasswordSubmit= this.chnagePasswordSubmit.bind(this);
		this.setVerifyPassword=this.setVerifyPassword.bind(this);
		this.checkOldPass=this.checkOldPass.bind(this);
	}
	// change password submit form
	chnagePasswordSubmit(e){
		e.preventDefault();
		var oldpass= document.ChangePassword.oldPassword.value;
		var newpass= document.ChangePassword.newPassword.value;
		var verifypass= document.ChangePassword.verifyPassword.value;
		var email = document.ChangePassword.currentEmail.value;
		var validation=true;
		if(oldpass===''){
			this.setState({
				oldPassReq: 'Please input your existing password.'
			});
			validation=false;
			return false;
		}else{
			this.setState({
				oldPassReq: ''
			});
		}
		if(newpass===''){
			this.setState({newPassReq:'Please input your new password.'});
			validation=false;
			return false;
		}else{
			this.setState({newPassReq:''});
		}
		 if(verifypass===''){
			this.setState({passMisMatchText:'Retype your password again.'});
			validation=false;
			return false;
		}else{
			this.setState({passMisMatchText:''});
		}

		if(newpass===oldpass){
			this.setState({newPassReq:'New password is same as existing password.'});
			validation=false;
			return false;
		}else{
			this.setState({newPassReq: ''});
		}
		if(newpass!==verifypass){
			this.setState({
				passMisMatchText: 'Verify Password is not matched to new entered password.'
			});
			validation=false;
			return false;
		}else{
			this.setState({passMisMatchText: ''});
		}
		if(validation===true){
			this.props.updatePassword(email,oldpass,newpass);
		}
	}
	setVerifyPassword(){
		var newpass= document.ChangePassword.newPassword.value;
		var verifypass= document.ChangePassword.verifyPassword.value;
	    if(verifypass===''){
	        this.setState({passMisMatchText:'Please verify your password.'});
	    }else{
	        this.setState({passMisMatchText:''});
	    }
	    if(verifypass!==newpass){
	        this.setState({passMisMatchText:"Password do not match."});
	    }else{
	        this.setState({passMisMatchText:""});
	    }
	  }
	onLogout() {
      window.localStorage.removeItem('agl-token');
      this.props.history.push('/login');
    }
    setPassword(e){
	    let pass= e.target.value;
	    if (pass.length < 6) {
	        this.setState({newPassReq:"Password is too short."});
	    } else if (pass.length > 50) {
	        this.setState({newPassReq:"Password is too long."});
	    } else if (pass.search(/\d/) === -1) {
	        this.setState({newPassReq:"Password must contain letters and numbers."});
	    } else if (pass.search(/[a-zA-Z]/) === -1) {
	        this.setState({newPassReq:"Password must contain letters and numbers."});
	    }else{
	      this.setState({newPassReq:""});
	    }
	} 
	checkOldPass(e){
		var oldpass= e.target.value;
		var email = document.ChangePassword.currentEmail.value;
		if(email!='' && oldpass!=''){
			this.props.checkOldPassword(email,oldpass);
		}
	}
	render(){
		let userName =  this.props.currentuser.currentUser ? this.props.currentuser.currentUser.name : 'user name';
    	let userEmail = this.props.currentuser.currentUser ? this.props.currentuser.currentUser.email : 'useremail@gmail.com';
    	let $imagePreview=null;
    	let check=this.props.currentuser.currentUser && this.props.currentuser.currentUser.image && this.props.currentuser.currentUser.image!=='';
    	var path=apiUrl;
    	if(check){
      		$imagePreview = (<img src={this.props.currentuser.currentUser.image.location} alt="user" />);
    	}else{
      		$imagePreview = (<img src="/images/user-img.jpg" alt="user" />);
    	}
		return(<div>
					<Header />
					<div className="dashboard-page">
						<div className="right-content-dashboard active-dashboard">
							<div className="change-password-content">
								<Row>
									<Col md={4}>
										<div className="profile-pic-section">
											<figure>
												{$imagePreview}
											</figure>
											<h3>{userName}</h3>
											<p><MdEmail /> {userEmail}</p>
										</div>
									</Col>
									<Col md={8} className="padl10">
										<div className="chenge-password-form">
											<div className="heading-sec">
												<h3>Change Password</h3>
											</div>
											 <form name="ChangePassword" onSubmit={this.chnagePasswordSubmit}>
			                                     <Row>
			                                        <Col md={12}>
			                                            <TextField
			                                                fullWidth={ true }
			                                                floatingLabelText="Enter old password *"
			                                                type="password"
			                                                name="oldPassword"
			                                                required={ this.state.oldPassReq }
			                                                onChange={this.checkOldPass}
			                                                errorText={this.props.editPasss.checkPasswordError?'Please enter correct password.':this.state.oldPassReq}
			                                            />
			                                        </Col>
			                                    </Row>
			                                    <Row>
			                                        <Col md={12}>
			                                            <TextField
			                                                fullWidth={ true }
			                                                floatingLabelText="New password"
			                                                type="password"
			                                                name="newPassword"
			                                                onChange={this.setPassword}
			                                                errorText={ this.state.newPassReq }
			                                            />
			                                        </Col>
			                                    </Row>
			                                    <Row>
			                                        <Col md={12} className="margb20px" >
			                                            <TextField
			                                                fullWidth={ true }
			                                                floatingLabelText="Verify password"
			                                                type="password"
			                                                name="verifyPassword"
			                                                required={ this.state.passMatchReq }
                                                			errorText= { this.state.passMisMatchText }
                                                			onChange={this.setVerifyPassword}
			                                            />
			                                        </Col>
			                                    </Row>
			                                    <Row>
			                                        <Col md={12}>
			                                          <input type='hidden' name="currentEmail" value={userEmail}/>
			                                          <div className="submit-buttton">
			                                           <RaisedButton label="Update Password" type="submit" labelColor="#fff" fullWidth={false} />
			                                          </div>
			                                        </Col>
			                                    </Row>
			                                 </form>
										</div>
									</Col>
								</Row>
							</div>
						</div>
					</div>
			   </div>
			)
	}
}

const mapStateToProps= (state,props)=> {
    return {
      currentuser: state.login,
      editPasss: state.profile
    };
}
export default connect(mapStateToProps,actions)(ChangePassword);


// WEBPACK FOOTER //
// ./src/Components/Pages/ChangePassword.js